import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Observable, map } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SvgService {
  constructor(
    private readonly http: HttpClient,
    private readonly sanitizer: DomSanitizer
  ) {}

  getSvg(url: string): Observable<SafeHtml> {
    return this.http
      .get(url, { responseType: "text" })
      .pipe(map((svg: string) => this.sanitizer.bypassSecurityTrustHtml(svg)));
  }
}
